/* eslint-disable no-nested-ternary */
import React from 'react';
import { bool, func, arrayOf, object, string } from 'prop-types';
import { FiRotateCw } from 'react-icons/fi';

import Modal from 'components/Modal';

import {
  Container,
  WrapperBody,
  WrapperContent,
  WrapperBottom,
  BottomText,
  ContentText,
  ContainerModal,
  Card,
  Header,
  Close,
} from './styles';
import { CircularProgress } from '@material-ui/core';

export default function LoadingModal({ open, reload, onClose }) {
  return (
    <Container>
      <Card>
        <Header>
          Carregando...
          <Close onClick={onClose} />
        </Header>
        <ContainerModal>
          <ContentText>
            <CircularProgress
              style={{ marginBottom: '0.6rem' }}
              size="1.6rem"
            />
            <strong>Estamos carregando a rota!</strong>
          </ContentText>
        </ContainerModal>
      </Card>
    </Container>
  );
}

LoadingModal.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
};
